import { useSelector } from "react-redux";
import { getCompanyData } from "../../selectors";
import { ICompanyData } from "../../interfaces/CompanyData";

export const useCompanyData = (): ICompanyData => {
  const result = useSelector(getCompanyData);
  return result;
};
